import { useContext } from "react";
import { Typography, Container, GridLegacy as Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import {
  IContext,
  IGetBookingsWithPairedJourneyParameters,
  IGetBookingsWithPairedJourneyResponse,
  RequestStatus,
} from "../../../logic/api";
import { SessionContext } from "../../../utility/useSession";
import ResultCard from "./components/ResultCard";
import Search from "./components/Search";
import { BarcodeScannerProvider } from "../../../context/barcode-scanner-context";

interface IPairedJourneysProps {
  data: IGetBookingsWithPairedJourneyResponse | null;
  status: RequestStatus;
  getData: (
    context: IContext,
    args: IGetBookingsWithPairedJourneyParameters,
  ) => void;
}

function PairedJourneys({ data, status, getData }: IPairedJourneysProps) {
  const { t } = useTranslation();
  const session = useContext(SessionContext);
  const loading = status === RequestStatus.loading;

  function handleSearch(params: IGetBookingsWithPairedJourneyParameters) {
    getData(session.current.context, params);
  }

  return (
    <Container>
      <Grid container columns={5} spacing={1}>
        <Grid item xs={1}>
          <Search onSearch={handleSearch} disabled={loading} />
        </Grid>
        <Grid
          item
          xs
          sx={{
            maxHeight: 640,
            overflowX: "scroll",
            gap: 1,
            display: "flex",
            flexDirection: "column",
            my: 1,
          }}
        >
          {loading ? (
            <Typography>{t("general.loading")}...</Typography>
          ) : data?.results.length ? (
            data.results.map((r) => <ResultCard result={r} key={r.id} />)
          ) : status === RequestStatus.loaded ? (
            <Typography>{t("input.validations.noResults")}.</Typography>
          ) : (
            <Typography>{t("pair.searchInstructions")}</Typography>
          )}
        </Grid>
      </Grid>
    </Container>
  );
}

export default function WithBarcodeScanner(props: IPairedJourneysProps) {
  return (
    <BarcodeScannerProvider>
      <PairedJourneys {...props} />
    </BarcodeScannerProvider>
  );
}
